import { useEffect } from 'react'

export default function useSliceCards(
  cards: string[],
  setPlayer: any,
  setRiver: any,
  setDealer: any,
) {
  useEffect(() => {
    if (cards) {
      setPlayer(cards.slice(0, 2))
      setRiver(cards.slice(2, 7))
      setDealer(cards.slice(7, 9))
    }
  }, [cards, setDealer, setPlayer, setRiver])
}
